import en from './en';
import cn from './cn';
import ru from './ru';
export default {
    en: en,
    cn: cn,
    ru: ru
}


// WEBPACK FOOTER //
// ./src/utils/i18n/langs/index.js